import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

//tasks
import tasks from "./tasks/reducer"

import filter from "./filter/filterReducer"
import adminFilter from "./adminFilter/filterReducer"
import Auth from "./Auth/AuthReducer"
import Mode from "./Mode/modeReducer"

const rootReducer = combineReducers({
  // public
  Layout,
  tasks,
  filter,
  adminFilter,
  Auth,
  Mode
})

export default rootReducer
